/* istanbul ignore file */
export { isPromise } from './isPromise';
export { isPromiseLike } from './isPromiseLike';
export {
  isPromiseFulfilledResult,
  isPromiseRejectedResult,
  isPromiseSettledResult,
} from './isPromiseSettledResult';
export {
  hasTransformStep,
  isSettled,
  isSettledLeft,
  isSettledRight,
} from './isSettled';
